"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _types = require("@nicbase/types");

var _nicbaseTranslation = require("nicbase-translation");

var _errorCodeMapping = require("../error-code-mapping");

var _nicStatusMapping = require("./nic-status-mapping");

var _excluded = ["status", "className", "iconProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var errorCodeStatusTypes = Object.values(_types.LatestDataErrorCodeStatusType);
var alarmStatusTypes = Object.values(_types.LatestDataAlarmStatusType);

var Status = function Status(_ref) {
  var status = _ref.status,
      className = _ref.className,
      iconProps = _ref.iconProps,
      props = _objectWithoutProperties(_ref, _excluded);

  var intl = (0, _nicbaseTranslation.useIntl)();
  var reeferErrorCodeTranslations = (0, _errorCodeMapping.makeErrorCodesTranslations)(intl);

  if (!status) {
    return null;
  }

  var type = status.type; // reefer

  var icon = null;
  var title = ''; // error code status

  if (errorCodeStatusTypes.some(function (errorCodeStatusType) {
    return errorCodeStatusType === status.type;
  })) {
    var _ref2 = status,
        codes = _ref2.codes,
        manufacturer = _ref2.manufacturer,
        severity = _ref2.severity;

    if (manufacturer) {
      icon = (0, _errorCodeMapping.reeferErrorCodeToIcon)(manufacturer, severity);
      title = reeferErrorCodeTranslations(manufacturer)(codes).map(function (translationKey) {
        return intl.formatMessage({
          id: translationKey
        });
      }).join('\n');
    }
  } // alarm and simple status


  if (!icon) {
    icon = (0, _nicStatusMapping.statusToIcon)(type);
    var alarmNames = null;

    if (alarmStatusTypes.some(function (alarmStatusType) {
      return alarmStatusType === status.type;
    })) {
      var _ref3 = status,
          statusAlarmNames = _ref3.alarmNames;
      alarmNames = statusAlarmNames;
    }

    if (Array.isArray(alarmNames)) {
      title = alarmNames.join('\n');
    } else {
      var statusTranslation = (0, _nicStatusMapping.statusToTranslation)(type);

      if (statusTranslation) {
        title = intl.formatMessage({
          id: statusTranslation
        });
      }
    }
  }

  if (!icon) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: className,
    role: "img",
    title: title
  }, props), /*#__PURE__*/_react["default"].createElement(icon, iconProps));
};

Status.defaultProps = {
  className: 'inline-block',
  iconProps: {
    className: 'h-6 w-6'
  }
};
var _default = Status;
exports["default"] = _default;